export const AUTH_PREFIX = '/auth'
export const EVENT_PREFIX = '/event'
export const MEMBER_PREFIX = '/member'
export const MEDIA_PREFIX = '/media'
export const PRESENTATION_PREFIX = '/presentation'
export const CHAT_PREFIX = '/chat'
export const TESTS_PREFIX = '/quiz'
export const STATIC_PREFIX = '/static'
